import type { IllustrationProps } from "./Frame";
import { illustrations, type IllustrationName } from "./registry";

export interface IllustrationComponentProps extends IllustrationProps {
  readonly name: IllustrationName;
}

/** Render an illustration by registry name (decorative, `aria-hidden`). */
export function Illustration({ name, size, className }: IllustrationComponentProps) {
  const Component = illustrations[name];
  return <Component size={size} className={className} />;
}
